import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { AuthService } from '../../../services/auth.service'
import { ErrorService } from '../../../services/error.service'
import { SpinnerService } from '../../../services/spinner.service'
import { DialogService } from '../../../services/dialog.service'
import { Router, RouterModule } from '@angular/router'
import {
  FormBuilder,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { ResetPasswordBody } from '../../../types/auth'
import { firstValueFrom } from 'rxjs'
import { ApiError } from '../../../types/apiError'
import { Dialog } from '@angular/cdk/dialog'
import { TranslationService } from '../../../services/translation.service'

@Component({
  selector: 'app-reset-password',
  imports: [
    MatFormFieldModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    RouterModule,
  ],
  templateUrl: './reset-password.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './reset-password.component.scss',
})
export class ResetPasswordComponent {
  authService = inject(AuthService)
  errorService = inject(ErrorService)
  spinnerService = inject(SpinnerService)
  dialogService = inject(DialogService)
  router = inject(Router)
  formBuilder = inject(FormBuilder)
  dialog = inject(Dialog)
  translationService = inject(TranslationService)

  emailForm = this.formBuilder.group({
    email: ['', [Validators.required, Validators.email]],
  })

  async submit() {
    try {
      if (!this.emailForm.valid) {
        return
      }
      this.spinnerService.startSpinner()
      const resetPasswordBody: ResetPasswordBody = this.emailForm
        .value as ResetPasswordBody

      await firstValueFrom(this.authService.resetPassword(resetPasswordBody))
      this.spinnerService.stopSpinner()
      this.dialogService.showDialog(
        this.dialog,
        this.translationService.getUsersText(),
        this.translationService.getRequestResetPasswordSuccessText(),
        undefined,
        this.router,
        '/auth/login',
      )
    } catch (err) {
      this.spinnerService.stopSpinner()
      const apiErr = err as ApiError
      this.errorService.handleErr(this.dialogService, apiErr, this.dialog)
    }
  }
}
